import { MdAdd, MdOutlineSearch } from 'react-icons/md'

import type { ReactElement } from 'react'

import Banner from '~/components/Banner'
import Button from '~/components/Buttons/Button'
import VanillaTextInput from '~/components/Inputs/Basic/TextInput'
import TextInput from '~/components/Inputs/Formik/TextInput'
import LastUpdatedByCard from '~/components/LastUpdatedByCard'

import './styles.scss'

interface Props {
  addButtonText?: string
  dirty?: boolean
  isReviewEngine?: boolean
  isSubmitting?: boolean
  metadata?: {
    updatedAt: number
    updatedBy: string
  }
  onAdd?: VoidFunction
  onSave?: VoidFunction
  onSearch?: (value: string) => void
  onUndo?: VoidFunction
}

const ActionHeader = ({
  addButtonText = 'Add',
  dirty = false,
  isReviewEngine,
  isSubmitting = false,
  metadata,
  onAdd,
  onSave,
  onSearch,
  onUndo,
}: Props): ReactElement => {
  return (
    <div className="action-header">
      <div className="action-header__version">
        {onSearch ? (
          <VanillaTextInput
            className="placement-search-input"
            icon={<MdOutlineSearch size={16} />}
            onChange={(evt) => onSearch(evt.target.value)}
            placeholder="Search by placement"
          />
        ) : null}
        {isReviewEngine ? <TextInput name="version" placeholder="Version" withErrorWrapper={false} /> : null}
        {onAdd ? (
          <Button onClick={onAdd} type="button">
            <MdAdd color="#fff" size={16} />
            {addButtonText}
          </Button>
        ) : null}
      </div>
      <div className="action-header__actions">
        {dirty ? <Banner variant="warning">You have unsaved changes</Banner> : null}
        {metadata ? (
          <LastUpdatedByCard
            className="placement-metadata"
            size="small"
            updatedBy={{ date: metadata.updatedAt, name: metadata.updatedBy, userId: metadata.updatedBy }}
          />
        ) : null}
        {onSave ? (
          <Button disabled={!dirty || isSubmitting} onClick={onSave} type="button">
            Save
          </Button>
        ) : null}
        {onUndo && dirty ? (
          <Button ghost onClick={onUndo} type="button">
            Undo
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export default ActionHeader
